module.exports = __webpack_public_path__ + "img/sauna-room-icon.d63784ff.png";